import axios from 'axios'
var jwt = require('jsonwebtoken');
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro'

const getDefaultState = () => {
    return {
        token: false,
        contract: null,
        renewing: false,
        token_expires: false,
        token_expired: false,
        apoMobileNo: false,
        admin: false,
        ScreeningPortal: false,
        developer: false,
        auth: false,
        authError: false,
        clients: [],
        user: {
            kd: null,
            name: null,
            id: null,
        },        
    }
  }

export const state = getDefaultState()

export const getters = {
    getSMSNo(state) {
        return state.apoMobileNo;
    },
    contractSigned(state) {
        return state.contract;
    },
    AccessTokenExpired(state) {
        return state.token_expired;
    },
    AccessTokenData(state) {
        return jwt.decode(state.token);
    },
    isAdmin(state) {
        return state.admin;
    },
    developer(state) {
        return state.developer;
    },
    person(state) {
        if(state.user.person == "") {
            return "Organisations Admin";
        } else {
            return state.user.person;
        }
    },
    autherror(state) {
        return state.authError;
    },
    user(state) {
        return state.user;
    },
    auth(state) {
        return state.auth == true;
    },
    accessToken(state) {
        return state.token;
    },
    getClients(state) {
        return state.clients;
    },
    ScreeningPortalEnabled(state) {
        return state.ScreeningPortal == true;
    },
    ScreeningPortalDelay(state) {
        return parseFloat(state.ScreeningPortalDelay);
    }
  }

export const mutations = {
    ClearLogin(state) {
        state.user = {}
        state.auth = false;
        state.token =false;
    },
    SetUser(state, user) {
        state.user = user;
    },
    SetToken(state, access_token) {
        state.token = access_token;
        state.token_expires = jwt.decode(access_token).exp;
        state.token_expired = false;
        localStorage.setItem("at", state.token);    
        state.auth = true;
    },
    SetAuthError(state,error) {
        state.authError = error;
    },
    ClearaState(state) {
        state.tests = {};
    },
    setAdmin(state, admin) {
        state.admin = admin;
    },
    setClients(state, clients) {
        state.clients = clients;
    },
    updateClient(state, client) {
        const stateClient = state.clients.find(c => c.id === client.id);
        
        if ('apoName' in client.data) {
            client.data['name'] = client.data['apoName'];
            delete client.data['apoName'];
        }

        Object.assign(stateClient, client.data);
    },
    SetScreeningPortal(state, portal){
        state.ScreeningPortal = portal;
    },
    SetScreeningPortalDelay(state, delay) {
        state.ScreeningPortalDelay = parseFloat(delay);
    },
    TokenExpired(state, ss) {
        state.token_expired = ss;
    },
    setContract(state, contract) {
        state.contract = contract;
    },
    setSMSNumber(state, num) {
        state.apoMobileNo = num;
    }
}
export const actions = {
    QRCodeAuth(state, token) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_SERVER + "/auth/qrlogin?token="+token).then((response) => {
                let { token = false, user= null} = response.data;
                state.commit("SetToken", token);
                state.dispatch("FetchUserParameters")
                state.commit("SetUser", user);
                state.dispatch("LoadInitialData")
                resolve(true);
            }).catch(() => {
                reject(false);
            })          
        })       
    },
    ClearState(state) {
        Object.assign(state, getDefaultState())
    },
    Logout(state) {
        state.commit("ClearLogin");
        state.dispatch("ClearState");
    },
    FetchUserClients(state) {
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_SERVER + "/pharmacy/clients/", { headers: { Authorization: 'Berear '+state.getters.accessToken} })
            .then((response) => {
                state.commit("setClients", response.data)
            })
        });
    },
    UpdateUserClient(state, info) {
        console.log("UpdateUserClients", info.id, info.data)
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            axios.put(process.env.VUE_APP_API_SERVER + "/pharmacy/" + info.id, info.data , { headers: { Authorization: 'Berear '+state.getters.accessToken} })
            // eslint-disable-next-line no-unused-vars
            .then((response) => {
                resolve(true);
            }).catch((e) => {
                console.log(e);
                reject(false);
            })
        });
    },
    AddUserClient(state, data) {
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_SERVER + "/pharmacy/", data , { headers: { Authorization: 'Berear '+state.getters.accessToken} })
            // eslint-disable-next-line no-unused-vars
            .then((response) => {
                resolve(true);
            }).catch((e) => {
                console.log(e);
                reject(false);
            })
        });
    },
    FetchUserParameters(state) {
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_SERVER + "/parameters", { headers: { Authorization: 'Berear '+state.getters.accessToken} })
            .then((response) => {
                state.commit("setAdmin", response.data.admin)
                state.commit("setContract", response.data.contract)
                state.commit("setSMSNumber", response.data.sms);
                if(response.data.admin) {
                    state.dispatch("FetchUserClients");
                }
                state.commit("SetScreeningPortal", response.data.screeningPortal);
                state.commit("SetScreeningPortalDelay", parseFloat(response.data.screeningPortalDelay));
                resolve(true)
            })
            .catch(() => {
                reject(false);
            })
        });
    },
    ForceRelogin() {
        console.log("FORCE RELOADING");
    },
    RefreshToken(state) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_SERVER + "/auth/renewToken", {}, { headers: { Authorization: 'Berear '+state.getters.accessToken} })
            .then((r) => {
                if(r.status == 201) {
                    state.commit("SetToken", r.data.token);
                    state.dispatch("LoadInitialData");
                    resolve(true);
                }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((e) => {
                reject(false);
            })
        });
    },
    /*
    TryAutoLogin(state,data) {
        return new Promise((resolve, reject) => {
            const fpPromise = FingerprintJS.load({ token: 'uR5Y3Qow1xu0SFcbVmFP', region: "eu" })
            fpPromise
            .then(fp => fp.get())
            .then(result => {
                axios.get(process.env.VUE_APP_API_SERVER + "/auth/fingerprintlookup/"+result.visitorId)
                .then((r) => {
                    if(r.data.success) {
                        resolve(r.data.email);
                    } else {
                        reject(false);
                    }
                })
            })
        });
    },
    */
    Login(state,data) {
        return new Promise((resolve, reject) => {

            //const fpPromise = FingerprintJS.load({ token: 'uR5Y3Qow1xu0SFcbVmFP', region: "eu" })
            //fpPromise
            //.then(fp => fp.get())
            //.then(result => {
                var base = Buffer.from(data.username+":"+data.password).toString('base64');
                //axios.post(process.env.VUE_APP_API_SERVER + "/auth/login", { fp: result.visitorId }, { headers: { 'Authorization': 'Basic '+base } })
                axios.post(process.env.VUE_APP_API_SERVER + "/auth/login", { fp: "xxx" }, { headers: { 'Authorization': 'Basic '+base } })
                .then((response) => {
                    let { token = false, user= null} = response.data;
                    state.commit("SetToken", token);
                    state.commit("SetUser", user);
                    state.dispatch("LoadInitialData");
                    setInterval(() => {
                        if(Date.now()+15000 > state.state.token_expires*1000) {
                            state.commit("TokenExpired", true);
                        }
                    }, 1500);
                    state.dispatch("FetchUserParameters").then(() => {
                        resolve(user);
                    })    
                })
                .catch(() => {
                    state.commit("SetAuthError", true)
                    setTimeout(() => {
                        state.commit("SetAuthError", false)
                    }, 1500)                
                    reject(false);
                })
            //})
        })
    }
}


export default {
    namespaced: false,
    state,
    getters,
    actions, 
    mutations
  }